import { render, staticRenderFns } from "./DeviceTraitedDataByDeviceReferentielMetricDatatableWidgetComponent.vue?vue&type=template&id=615aa98d&"
import script from "./DeviceTraitedDataByDeviceReferentielMetricDatatableWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./DeviceTraitedDataByDeviceReferentielMetricDatatableWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports